@import url("../../global/global.css");

:host {
  display: inline;
  width: 100%;
}

.dc-card-group {
  column-gap: 32px;
  display: grid;
  row-gap: 32px;
  padding-bottom: 16px;
}

@media (--breakpoint-tablet) {
  .dc-card-group {
    column-gap: 48px;
    grid-template-columns: 1fr 1fr;
    row-gap: 48px;
  }
}

@media (--breakpoint-desktop) {
  .dc-card-group {
    grid-template-columns: 1fr 1fr 1fr;
  }

  .dc-card-group.four-items {
    grid-template-columns: 1fr 1fr 1fr 1fr;
  }
}
